import React from 'react'
import SliderGallery from '../components/SliderGallery'



const HarlandGallery = () => {

  const galleryImages = [
    {
      img: "/assets/Dec-7-Harland-Image-2-v1.2-HighRes.jpg",
      alt:'Dec-Tec membrane in various applications and settings 1'
    },
    {
      img: "/assets/Harland/1000007276.jpg",
      alt:'Dec-Tec membrane in various applications and settings 2'
    },
    {
      img: "/assets/Harland/1000007277.jpg",
      alt:'Dec-Tec membrane in various applications and settings 3'
    },
    {
      img: "/assets/Harland/1000007278.jpg",
      alt:'Dec-Tec membrane in various applications and settings 4'
    },
    {
      img: "/assets/Harland/Harland.jpg",
      alt:'Dec-Tec membrane in various applications and settings 5'
    },
    {
      img: "/assets/Harland/IMG_7196.jpeg",
      alt:'Dec-Tec membrane in various applications and settings 6'
    },
    {
      img: "/assets/Harland/IMG_7197.jpeg",
      alt:'Dec-Tec membrane in various applications and settings 7'
    },
    {
      img: "/assets/Harland/IMG_7198.jpeg",
      alt:'Dec-Tec membrane in various applications and settings 8'
    },
    {
      img: "/assets/Harland/IMG_7199.jpeg",
      alt:'Dec-Tec membrane in various applications and settings 9'
    }
  ]

  return (
    <div>
      <SliderGallery
        title="Harland"
        para1="Modern style and functional performance. Invite Harland to your deck today. Combining both a cool gray color and slatted wood design, you’ll impress yourself and your guests."
        galleryImages={galleryImages}
        previouslink="/products/membranes/classic-line"
        nextlink="/rowan-gallery/"
      />
    </div>
  )
}

export default HarlandGallery
